import MemoryList from "./MemoryList";
export default function MemoryTabRecente() {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        O que a IA viu nas últimas horas. Esquece rápido se não for reforçado.
      </p>
      <MemoryList layers={["recent", "episodic"]} emptyHint="Nenhuma memória recente. A IA precisa observar mais." />
    </div>
  );
}
